import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BorderTopOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderTopOutlined";
import AntdIcon from "../components/AntdIcon";
var BorderTopOutlined = function BorderTopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BorderTopOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BorderTopOutlined.displayName = 'BorderTopOutlined';
}
export default /*#__PURE__*/React.forwardRef(BorderTopOutlined);